import { langObject } from '../assets/LanguageData'
import { updateLanguage } from '../../../src/app/modules/auth/core/_requests' //module "c:/Projects/VDSoftware/AISenseUs/Api/Dashboard/src/app/modules/auth/core/_requests"
const I18N_CONFIG_KEY = process.env.REACT_APP_I18N_CONFIG_KEY || 'i18nConfig'

export type SupportedLang = 'en' | 'tr' | 'de' | 'ar' | 'ru'

type Props = {
  selectedLang: SupportedLang
}

const supportedLangs: SupportedLang[] = ['en', 'tr', 'de', 'ar', 'ru']

const initialState: Props = {
  selectedLang: 'en',
}

function isSupportedLang(lang: string): lang is SupportedLang {
  return supportedLangs.includes(lang as SupportedLang)
}

function applyDocumentLanguage(lang: SupportedLang) {
  if (typeof document === 'undefined') return
  document.documentElement.lang = lang
  // Full Metronic RTL CSS is not enabled; keep LTR chrome for layout stability.
  document.documentElement.dir = 'ltr'
}

export function LanguageHelp(text: string) {
  const lang = getConfig()
  const resultKeywordObject = langObject[text as keyof typeof langObject]
  if (resultKeywordObject === undefined){
    console.log("a new keyboard: ", text)
    return text
  }
  const resultKeyword = resultKeywordObject[(lang.selectedLang + "") as keyof typeof resultKeywordObject]
  if (resultKeyword === undefined)
    return text
  return resultKeyword

}

/** True when filter value is empty or equals the English key / current-locale label for that key. */
export function isAllFilter(value: string | null | undefined, englishKey: string) {
  if (value == null || String(value).trim() === '') return true
  const v = String(value).trim()
  return v === englishKey || v === LanguageHelp(englishKey)
}

export function getConfig(): Props {
  const ls = localStorage.getItem(I18N_CONFIG_KEY)
  // console.log(ls, "ls")
  if (ls) {
    try {
      const parsed = JSON.parse(ls) as Props
      if (parsed?.selectedLang && isSupportedLang(parsed.selectedLang)) {
        applyDocumentLanguage(parsed.selectedLang)
        return parsed
      }
    } catch (er) {
      console.error(er)
    }
  }
  let initial = { ...initialState }
  const browserLang = navigator.language.split('-')[0]
  if (isSupportedLang(browserLang)) {
    initial.selectedLang = browserLang
    setLanguage(initial.selectedLang, false)
  }
  applyDocumentLanguage(initial.selectedLang)
  return initial
}

// Side effect
export function setLanguage(lang: string, reload = true, writeDatabase = false) {
  const selectedLang = isSupportedLang(lang) ? lang : 'en'
  localStorage.setItem(I18N_CONFIG_KEY, JSON.stringify({ selectedLang }))
  applyDocumentLanguage(selectedLang)
  if (writeDatabase) {
    updateLanguage(selectedLang, reload)
  }
  if (reload && writeDatabase === false) {
    window.location.reload()
  }
}
